export const INITIAL_ARRAY_SIZE = 25;
export const INITIAL_SPEED = 50;
export const SPEED_SCALE = 5;
